import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { radiusTokens } from '@/theme/themePrimitives';

/** Same frame as the form: title, stepper and the step paper. */
const OnboardingSkeleton = () => (
  <Stack gap={3} sx={{ width: '100%', maxWidth: 880, mx: 'auto' }} aria-busy="true">
    <Stack gap={1}>
      <Skeleton variant="text" width="45%" height={36} />
      <Skeleton variant="text" width="65%" />
    </Stack>
    <Skeleton variant="rounded" height={32} />
    <Paper variant="outlined" sx={{ p: 3.5, borderRadius: radiusTokens.xxl }}>
      <Stack gap={2}>
        <Skeleton variant="rounded" width={72} height={72} />
        <Skeleton variant="rounded" height={48} />
        <Skeleton variant="rounded" height={48} />
        <Skeleton variant="rounded" height={96} />
      </Stack>
    </Paper>
  </Stack>
);

export default OnboardingSkeleton;
